import { render, staticRenderFns } from "./choose-item.vue?vue&type=template&id=2c912f2c"
import script from "./choose-item.vue?vue&type=script&lang=js"
export * from "./choose-item.vue?vue&type=script&lang=js"
import style0 from "./choose-item.vue?vue&type=style&index=0&id=2c912f2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports